import { useCallback } from 'react';
import {
    GET_LOGIN_API,
    GET_LOGOUT_API,
    GET_ME_CHECK_API,
    GET_ME_API,
    POST_LOGIN_GOOGLE_API,
    GET_LOGIN_GOOGLE_CONFIG_API,
} from './apiPath';
import { useHistory } from 'react-router-dom';
import useAxios from '@Apis/useAxios';
import { localUser } from '@Util/utils';

const useAuthApi = () => {
    const Axios = useAxios();
    const history = useHistory();

    const postLoginApi = useCallback(
        async (params, fn) => {
            const resp = await Axios.post(GET_LOGIN_API, params, fn);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    /**
     * Google 登入
     * @param {Object} params - { credential: Google 簽發的 ID Token }
     * @param {Object} fn - 回呼設定
     */
    const postGoogleLoginApi = useCallback(
        async (params, fn) => {
            const resp = await Axios.post(POST_LOGIN_GOOGLE_API, params, fn);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    /**
     * 取得 Google 登入設定 (是否啟用、ClientId)
     */
    const getGoogleLoginConfigApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_LOGIN_GOOGLE_CONFIG_API, {}, { isLoadingVisible: false });
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const getLogoutApi = useCallback(
        async () => {
            await Axios.get(
                GET_LOGOUT_API,
                {},
                {
                    callbackfn: (resultData, respBody) => {
                        const { success, statusCode } = respBody.data;
                        localUser.logout();
                        if (success && statusCode === '0000') {
                            history.push('/login');
                            window.location.reload();
                        } else {
                            alert('登出失敗，請重新整理畫面');
                        }
                    },
                }
            );
        },
        // eslint-disable-next-line
        []
    );

    const getCheckLocalDataApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_ME_CHECK_API);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const getLocalMeDataApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_ME_API);
            if (resp) return resp;
        },
        // eslint-disable-next-line
        []
    );

    return {
        postLoginApi,
        postGoogleLoginApi,
        getGoogleLoginConfigApi,
        getLogoutApi,
        getCheckLocalDataApi,
        getLocalMeDataApi,
    };
};

export default useAuthApi;
